export function scrollTo(target, options = {}) {
	options = Object.assign({
		context: "[role=\"main\"]",
		shift: 0,
		smooth: false,
		whenAboveView: false,
	}, options);

	let contextElement = document.querySelector(options.context);

	if (!contextElement) {
		return;
	}

	let scrollOptions = {
		behavior: options.smooth ? "smooth" : "auto",
	};

	if (Number.isInteger(target)) {
		scrollOptions.top = target + options.shift;
		return contextElement.scrollTo(scrollOptions);
	}

	let targetElement = contextElement.querySelector(target);
	console.log("scrollTo", "targetElement", targetElement);
	if (!targetElement) {
		return;
	}

	target = targetElement.offsetTop - contextElement.offsetTop;
	let currentOffset = targetElement.getBoundingClientRect().top - contextElement.offsetTop;
	let aboveView = currentOffset < 0;
	console.log("scrollTo", target, currentOffset, aboveView, options.whenAboveView, !aboveView && options.whenAboveView);
	if (!aboveView && options.whenAboveView) {
		return;
	}

	scrollOptions.top = target - options.shift;
	console.log("scrollTo final", target, options, "scrollOptions", scrollOptions);
	contextElement.scrollTo(scrollOptions);
}
